import React, {Component} from 'react';
import styled from "styled-components";
import GitFlow from "./gitflow";
import shortid from "shortid";

const DEVELOP = 'develop';
const MASTER = 'master';

const masterID = shortid.generate();
const developID = shortid.generate();

const seedData = () => {

    const commits = [
        {
            id: shortid.generate(),
            branch: masterID,
            gridIndex: 1,
            parents: null,
        },
        {
            id: shortid.generate(),
            branch: developID,
            gridIndex: 1,
            parents: null
        }
    ];
    return {
        branches: [
            {
                name: MASTER,
                id: masterID,
                canCommit: false,				
				releaseNo: 0,
				hotfixNo: 0,
                color: '#E040FB',
            },
            {
                name: DEVELOP,
                id: developID,
                canCommit: true,
                color: '#FF8A65',
            }
        ],
        commits
    }
};

const AppElm = styled.main`
  text-align: center;
  padding: 10px;
`;

class App extends Component {

    state = {
        project: seedData()
    };

    handleCommit = (branchID, mergeGridIndex = 0) => {
        let {commits} = this.state.project;
        const branchCommits = commits.filter(c => c.branch === branchID);
        const lastCommit = branchCommits[branchCommits.length - 1];
        commits.push({
            id: shortid.generate(),
            branch: branchID,
            gridIndex: lastCommit.gridIndex + mergeGridIndex + 1,
            parents: [lastCommit.id]
        });
        this.setState({
            commits
        });
    };

    handleNewFeature = () => {
        let {branches, commits} = this.state.project;
        let featureBranches = branches.filter(b => b.featureBranch);
        let featureBranchName = 'FET-' + Math.floor((Math.random() * 100) + 1);
        let developCommits = commits.filter(c => c.branch === developID);
        const lastDevelopCommit = developCommits[developCommits.length - 1];
        let featureOffset = lastDevelopCommit.gridIndex + 1;
        let newBranch = {
            id: shortid.generate(),
            name: featureBranchName,
            featureBranch: true,
            canCommit: true,
            color: '#64B5F6'
        };
        let newCommit = {
            id: shortid.generate(),
            branch: newBranch.id,
            gridIndex: featureOffset,
            parents: [lastDevelopCommit.id]
        };
        commits.push(newCommit);
        branches.push(newBranch);
        this.setState({
            project: {
                branches,
                commits
            }
        });
    };

    handleNewHotFix = () => {
        let {branches, commits} = this.state.project;
        let hotFixBranches = branches.filter(b => b.hotFixBranch);
		branches.find(b => b.id == masterID).hotfixNo+=1;
        let masterCommits = commits.filter(c => c.branch === masterID);
		let hotFixBranchName = branches.find(b => b.id == masterID).releaseNo + '.' + branches.find(b => b.id == masterID).hotfixNo;
        const lastMasterCommit = masterCommits[masterCommits.length - 1];
        let hotFixOffset = lastMasterCommit.gridIndex + 1;

        let newBranch = {
            id: shortid.generate(),
            name: hotFixBranchName,
            hotFixBranch: true,
            canCommit: true,
            color: '#ff1744'
        };
        let newCommit = {
            id: shortid.generate(),
            branch: newBranch.id,
            gridIndex: hotFixOffset,
            parents: [lastMasterCommit.id]
        };
        commits.push(newCommit);
        branches.push(newBranch);
        this.setState({
            project: {
                branches,
                commits
            }
        });
    };

    handleNewRelease = () => {
        let {branches, commits} = this.state.project;
        let releaseBranches = branches.filter(b => b.releaseBranch);
		branches.find(b => b.id == masterID).releaseNo+=1;
		branches.find(b => b.id == masterID).hotfixNo = 0;
        let releaseBranchName = branches.find(b => b.id == masterID).releaseNo + '.' + branches.find(b => b.id == masterID).hotfixNo;
        let developCommits = commits.filter(c => c.branch === developID);
        const lastDevelopCommit = developCommits[developCommits.length - 1];
        let releaseOffset = lastDevelopCommit.gridIndex + 1;
        let newBranch = {
            id: shortid.generate(),
            name: releaseBranchName,
            releaseBranch: true,
            canCommit: true,
            color: '#B2FF59'
        };
        let newCommit = {
            id: shortid.generate(),
            branch: newBranch.id,
            gridIndex: releaseOffset,
            parents: [lastDevelopCommit.id]
        };
        commits.push(newCommit);
        branches.push(newBranch);
        this.setState({
            project: {
                branches,
                commits
            }
        });
    };

    handleRelease = (sourceBranchID) => {
        let {branches, commits} = this.state.project;
        const sourceBranch = branches.find(b => b.id === sourceBranchID);		
        const sourceCommits = commits.filter(c => c.branch === sourceBranchID);
		const masterCommits = commits.filter(c => c.branch === masterID);
        const developCommits = commits.filter(c => c.branch === developID);
        const lastSourceCommit = sourceCommits[sourceCommits.length - 1];
        const lastMasterCommit = masterCommits[masterCommits.length - 1];
        const lastDevelopCommit = developCommits[developCommits.length - 1];

        const masterMergeCommit = {
            id: shortid.generate(),
            branch: masterID,
            gridIndex: Math.max(lastSourceCommit.gridIndex, lastMasterCommit.gridIndex) + 1,
			tag : 'v1.' + sourceBranch.name,
            parents: [lastMasterCommit.id, lastSourceCommit.id]
        };

        const developMergeCommit = {
            id: shortid.generate(),
            branch: developID,
            gridIndex: Math.max(lastSourceCommit.gridIndex, lastDevelopCommit.gridIndex) + 1,
            parents: [lastDevelopCommit.id, lastSourceCommit.id]
        };		
		
		let releaseBranches = branches.filter(b => b.releaseBranch);
		releaseBranches.forEach(r => {
		if(sourceBranch.id != r.id && ! r.merged){
			const releaseCommits = commits.filter(c => c.branch === r.id);
			const lastReleaseCommit = releaseCommits[releaseCommits.length - 1];
		
            const releaseMergeCommit = {
				id: shortid.generate(),
				branch: r.id,
				gridIndex: Math.max(lastSourceCommit.gridIndex, lastReleaseCommit.gridIndex) + 1,
				parents: [lastSourceCommit.id,lastReleaseCommit.id]
			};
		
			commits.push(releaseMergeCommit);
		}
			
        });
		
		let hotFixBranches = branches.filter(b => b.hotFixBranch);
		hotFixBranches.forEach(h => {
		if(sourceBranch.id != h.id && ! h.merged){
			const hotfixCommits = commits.filter(c => c.branch === h.id);
			const lastHotfixCommit = hotfixCommits[hotfixCommits.length - 1];
				const hotfixMergeCommit = {
				id: shortid.generate(),
				branch: h.id,
				gridIndex: Math.max(lastSourceCommit.gridIndex, lastHotfixCommit.gridIndex) + 1,
				parents: [lastSourceCommit.id,lastHotfixCommit.id]
			};
			commits.push(hotfixMergeCommit);
		}
        });

        commits.push(masterMergeCommit, developMergeCommit);
        sourceBranch.merged = true;

        this.setState({
            project: {
                branches,
                commits
            }
        });

    };

    handleMerge = (sourceBranchID, targetBranchID = developID) => {
        let {branches, commits} = this.state.project;

        const sourceBranch = branches.find(b => b.id === sourceBranchID);
        const sourceCommits = commits.filter(c => c.branch === sourceBranchID);
        const targetCommits = commits.filter(c => c.branch === targetBranchID);	

        const lastSourceCommit = sourceCommits[sourceCommits.length - 1];
        const lastTargetCommit = targetCommits[targetCommits.length - 1];

        const mergeCommit = {
            id: shortid.generate(),
            branch: targetBranchID,
            gridIndex: Math.max(lastSourceCommit.gridIndex, lastTargetCommit.gridIndex) + 1,
            parents: [lastSourceCommit.id, lastTargetCommit.id]
        };
        commits.push(mergeCommit);

        sourceBranch.merged = true;

        this.setState({
            project: {
                branches,
                commits
            }
        });
    };

    handleDeleteBranch = (branchID) => {
        let {branches, commits} = this.state.project;
		console.log(branches);
		console.log(commits);
        let commitsToDelete = commits.filter(c => c.branch === branchID);
        let lastCommit = commitsToDelete[commitsToDelete.length - 1];
        commits = commits.map(commit => {
            if (commit.parents) {
                commit.parents = commit.parents.filter(pID => pID !== lastCommit.id);
            }
            return commit;

        });
        branches = branches.filter(b => b.id !== branchID);
        commits = commits.filter(c => c.branch !== branchID);
        this.setState({
            project: {
                branches,
                commits
            }
        });
    };

    render() {
        return (
            <AppElm>
                <GitFlow
                    project={this.state.project}
                    onMerge={this.handleMerge}
                    onRelease={this.handleRelease}
                    onCommit={this.handleCommit}
                    onNewFeature={this.handleNewFeature}
                    onNewRelease={this.handleNewRelease}
                    onDeleteBranch={this.handleDeleteBranch}
                    onNewHotFix={this.handleNewHotFix}
                />
            </AppElm>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/app.js